import * as React from 'react'
import { TaskStatusesMain } from './TaskStatusesMain'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TaskStatusesMainExamples = () => {
  return (
    <div className="TaskStatusesMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskStatusesMain />
      </Provider>
    </div>
  )
}
